// Packages
import { useMemo } from "react";
import { useNow } from "@jkast90/kast-common/format/react";

// Components

// Styling
import styles from "./ReminderIcon.module.css";
import { toDate, type ShownReminder } from "./reminderShape";

export default function ReminderIcon({
  reminder,
  onClick,
}: {
  reminder?: ShownReminder | null;
  onClick?: () => void;
}) {
  const now = useNow();
  const remaining = useMemo(() => {
    if (!reminder?.due || reminder?.completed) return null;
    return Math.ceil((toDate(reminder.due).getTime() - now) / 60000);
  }, [reminder?.due, reminder?.completed, now]);

  const color = useMemo(() => {
    if (!reminder || reminder?.completed || remaining === null) return "gray";
    if (remaining <= 30) return "red";
    if (remaining <= 90) return "orange";
    if (remaining <= 180) return "yellow";
    return "green";
  }, [remaining, reminder]);

  const tooltip = reminder?.completed
    ? `Completed: ${toDate(reminder.completed).toLocaleString()}`
    : reminder?.due
      ? `Due: ${toDate(reminder.due).toLocaleString()}`
      : "No reminder set";

  return (
    <div
      data-tip={tooltip || undefined}
      className={styles.wrapper}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.();
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        className={`${styles.icon} ${styles[color]}`}
      >
        <path d="M12 1a11 11 0 1 0 11 11A11.013 11.013 0 0 0 12 1zm0 20a9 9 0 1 1 9-9 9.01 9.01 0 0 1-9 9zm.5-13h-1v6l5.25 3.15.5-.84-4.75-2.81z" />
      </svg>
    </div>
  );
}
